"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_CONFIG = exports.SEARCH_DELAY = exports.MIN_QUERY_LENGTH = void 0;
exports.MIN_QUERY_LENGTH = 2;
exports.SEARCH_DELAY = 500;
exports.SEARCH_CONFIG = {
    searchDelay: exports.SEARCH_DELAY,
    minQueryLength: exports.MIN_QUERY_LENGTH,
};
//# sourceMappingURL=constants.js.map